import { BlockIconForgot } from "./iconForgot/BlockIconForgot";

const DiscriptCancellation = ({ iconStatus, contentColor, text }) => {
  return (
    <>
      {iconStatus ? <BlockIconForgot color={contentColor} /> : <></>}
      <span
        dangerouslySetInnerHTML={{
          __html: text,
        }}
        style={{ color: contentColor }}
      />
    </>
  );
};

export { DiscriptCancellation };
